// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import SearchIcon from '@mui/icons-material/Search'
import { TextField, Typography } from '@mui/material'
import _ from 'lodash'
import React, { Component } from 'react'
import { Query } from 'react-apollo'
import type { User } from '../../admin/users/userTypes'
import Container from '../../common/container/Container'
import Loader from '../../common/loader/Loader'
import { alphaSort } from '../../common/utils'
import withUser from '../auth/withUser'
import Header from '../header/Header'
import { i18n } from '../index'
import withActiveStation from '../station/withActiveStation'
import FileLink from './components/fileLink/FileLink'
import css from './GuidelinesAndLinks.css'
import { fetchAokFileLinks, fetchFileLinks } from './queries'
type Props = {
  user: User
}
type State = {
  selected: string
  searchTerm: string
}
type Link = {
  href: string
  fileName: string
  linkTags:
    | {
        id: string
        name: string
      }[]
    | null
}

@withUser
@withActiveStation
class GuidelinesAndLinks extends Component<Props, State> {
  constructor() {
    super()
    this.state = {
      selected: '',
      searchTerm: '',
    }
  }

  groupAndOrderFileLinks = (links?: Link[]): { tagId: string; tag: string; links: Link[] }[] => {
    const { searchTerm } = this.state
    if (!links) {
      return []
    }
    const uniqueTags = _.uniqBy(
      links.flatMap((link) => link.linkTags ?? []),
      'id',
    )

    const groupedLinks = uniqueTags.map((tag) => ({
      tag: tag.name,
      tagId: tag.id,
      links: links.filter((link) => link.linkTags?.some((linkTag) => linkTag.id === tag.id)),
    }))
    groupedLinks.push({
      tag: i18n.t('linkTags.other'),
      tagId: 'other',
      links: links.filter((link) => !link.linkTags || link.linkTags.length === 0),
    })
    return groupedLinks
      .filter((group) => group.links.length > 0)
      .map((group) => ({
        tag: group.tag,
        links: alphaSort(
          'fileName',
          group.links.filter((link) => {
            if (!searchTerm) {
              return true
            }
            return (
              link.fileName.toLowerCase().includes(searchTerm.toLowerCase()) ||
              link.href.toLowerCase().includes(searchTerm.toLowerCase())
            )
          }),
        ),
      }))
      .filter((group) => group.links.length > 0)
  }

  render() {
    const stationId = this.props.activeStation && this.props.activeStation.id
    const { user } = this.props
    const { searchTerm } = this.state
    return (
      <div className={css.component}>
        <Header title={i18n.t('guidelinesAndLinks.header')} />
        <Container>
          <Typography variant='h6'>{i18n.t('guidelinesAndLinks.header')}</Typography>
          <div className={css.searchContainer}>
            <TextField
              className={css.searchField}
              value={searchTerm}
              onChange={(e) =>
                this.setState({
                  searchTerm: e.target.value,
                })
              }
              label={i18n.t('guidelinesAndLinks.searchLabel')}
            />
            <SearchIcon className={css.searchIcon} />
          </div>

          <Query
            query={fetchFileLinks}
            skip={!stationId}
            variables={{
              stationId,
            }}
          >
            {({ loading, error, data }) => {
              return (
                <Loader
                  {...{
                    loading,
                    error,
                  }}
                >
                  {data.fileLinks && (
                    <React.Fragment>
                      {!!data.favoriteFileLinks.length && <h3>{i18n.t('guidelinesAndLinks.favoritesHeading')}</h3>}
                      <div>
                        {this.groupAndOrderFileLinks(data.favoriteFileLinks).map((group) => (
                          <LinkGroup key={group.tagId} group={group} stationId={stationId} showFavBlock={false} />
                        ))}
                      </div>
                      <h3>{i18n.t('guidelinesAndLinks.generalTitle')}</h3>
                      <div>
                        {this.groupAndOrderFileLinks(data.fileLinks).map((group) => (
                          <LinkGroup
                            key={group.tagId}
                            group={group}
                            stationId={stationId}
                            showFavBlock={true}
                            favoriteFileLinks={data.favoriteFileLinks}
                          />
                        ))}
                      </div>
                    </React.Fragment>
                  )}
                </Loader>
              )
            }}
          </Query>

          <Query
            query={fetchAokFileLinks}
            variables={{
              companyId: user.company.id,
              stationId,
            }}
          >
            {({ loading, error, data }) => {
              return (
                <Loader
                  {...{
                    loading,
                    error,
                  }}
                >
                  {data.aokFileLinks && data.aokFileLinks.length > 0 && (
                    <React.Fragment>
                      <h3>{i18n.t('guidelinesAndLinks.aokTitle')}</h3>
                      <div>
                        {this.groupAndOrderFileLinks(data.aokFileLinks).map((group) => (
                          <LinkGroup
                            key={group.tagId}
                            group={group}
                            stationId={stationId}
                            showFavBlock={true}
                            favoriteFileLinks={data.favoriteFileLinks}
                          />
                        ))}
                      </div>
                    </React.Fragment>
                  )}
                </Loader>
              )
            }}
          </Query>
        </Container>
      </div>
    )
  }
}

interface LinkGroupProps {
  group: { tag: string; links: Link[] }
  stationId: string
  showFavBlock?: boolean
  favoriteFileLinks?: Link[]
}

function LinkGroup({ group, stationId, showFavBlock, favoriteFileLinks }: LinkGroupProps) {
  return (
    <>
      <h4>{group.tag}</h4>
      <div className={css.linksContainer}>
        {group.links.map((link) => (
          <FileLink
            stationId={stationId}
            key={link.id}
            id={link.id}
            fileName={link.fileName}
            href={link.href}
            showFavBlock={showFavBlock}
            isFavorited={showFavBlock && favoriteFileLinks?.find(({ id }) => id === link.id)}
          />
        ))}
      </div>
    </>
  )
}

export default GuidelinesAndLinks
